module.exports = __webpack_public_path__ + "media/images/shared/suppliers/DONGFENG-628172f3dc3cb26fea1739dca12b71ed.jpg";